<template>
  <div>
    <Subheader title="Start ChangeFunding Today!" />

    <div class="app-content-column">
      <div v-if="!userIsLoggedIn" style="margin-top: 1.5rem">
        <div class="is-centered">
          <h5>Welcome to the Alpha version of the Mzingo Partners app.</h5>
        </div>
        <div class="is-centered">
          <h6 style="line-height: 1.2rem">
            Click on the menu icon on the top left to sign up, create projects, and start following
            our growing number of Mzingo Partners projects.
          </h6>
        </div>
      </div>
      <div v-if="userIsLoggedIn" class="is-centered" style="margin-top: 1.5rem">
        <h5>Search for projects you can support to change lives.</h5>
      </div>
      <!-- <ProjectCard v-for="project in projects.slice(0, 2)" :key="project.id" :project="project" />
        Discover Card
        <div class="card">
          <h5>DISCOVER PROJECTS</h5>
          <p>View projects tailored to your interests and follow projects to see their progress!</p>
          <div class="button-wrapper" style="justify-content:space-around">
            <button class="medium-button medium-button--inverted" @click="onClickEndingSoon">
              Ending Soon
            </button>
            <button class="medium-button medium-button--inverted" @click="onClickCloseToGoal">
              Close to Goal
            </button>
            <button class="medium-button medium-button--inverted" @click="onClickThingsIdLike">
              My Interests
            </button>
          </div>
        </div> -->
      <!-- Removing Project Card for now, will introduce it after -->
      <Pagination
        :pagination-details="paginationDetails"
        :show-only-result-count="false"
        :hide-pages="true"
        @update="refreshData($event)"
      />
      <div class="button-wrapper is-centered">
        <router-link :to="{ name: 'MakerOnboarding' }">
          <button class="large-button">Create a New Project</button>
        </router-link>
      </div>
      <div class="results">
        <div v-if="loading">
          Loading...
        </div>
        <div v-if="!loading">
          <ProjectCard
            v-for="project in projects"
            :key="project.id"
            :project="project"
            class="project-card"
          />
          <Pagination
            :pagination-details="paginationDetails"
            :show-only-result-count="false"
            :hide-pages="true"
            @update="refreshData($event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'
import ProjectCard from '@/components/ProjectCard'
import Project from '@/services/projects'

import Pagination from '@/components/Pagination'
import { getPaginationDataFromResponse } from '@/services/utils/pagination'

import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {
    Subheader,
    ProjectCard,
    Pagination,
  },
  data() {
    return {
      projects: [],
      loading: true,
      // Mixins
      paginationDetails: {},
    }
  },
  computed: {
    ...mapGetters(['userIsLoggedIn']),
  },
  mounted() {
    this.refreshData()
  },
  methods: {
    async refreshData(page = null) {
      this.loading = true
      let filters = {}
      if (page) {
        filters = { page: page }
      }
      const data = await Project.api.list({ filters: filters })
      this.projects = data.results
      // Mixins
      this.paginationDetails = getPaginationDataFromResponse(data)
      this.loading = false
    },
    onClickEndingSoon() {
      this.$router.push({ name: 'SearchProjects' })
    },
    onClickCloseToGoal() {
      this.$router.push({ name: 'SearchProjects' })
    },
    onClickThingsIdLike() {
      this.$router.push({ name: 'SearchProjects' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/cards';
@import '../styles/mixins/buttons';
@import '../styles/layout';

.project-card {
  width: calc(100% - 2.5rem);
}
</style>
